/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { Component } from 'react';
import { View } from 'react-native';

import { showError, showSuccess } from '../App/AppAlert';
import connectData, { ConnectedProps } from '../../support/connectData';
import AccountActions from '../../support/AccountActions';
import { postJSON } from '../../support/Fetch';
import { Currencies } from '../../core/constants/Currencies';
import ensureObject from '../../support/shared/ensureObject';
import { canUser } from '../../support/shared/permissionHelpers';

import LoadingIndicator from '../uiold/LoadingIndicator';
import {
  Button,
  ButtonToolbar,
  Card,
  RadioGroup,
  RadioItem,
  Page,
  Text,
} from '../uiold';

import settingsStyles from '../Settings/styles';

import { Account } from '../../types/shared/Account';

type State = {
  isSaving: boolean;
  currency: string;
};

const validCurrencies = new Set<string>(Object.keys(Currencies));

class CurrencySettings extends Component<FullProps, State> {
  state: State = {
    isSaving: false,
    currency: getAccountCurrency(this.props.account),
  };

  render() {
    return (
      <Page>
        <Page.Header title="Currency">{this._renderSaveControls()}</Page.Header>
        <Card>{this._renderControl()}</Card>
      </Page>
    );
  }

  _renderControl = () => {
    let { currency } = this.state;
    let { user } = this.props;
    let items = Object.keys(Currencies).map((curCode) => (
      <RadioItem
        key={curCode}
        title={curCode}
        value={curCode}
        style={settingsStyles.radioItem}
      />
    ));
    return (
      <RadioGroup
        selectedValue={currency}
        onChange={(value) => {
          user &&
            canUser(user, { settings: 'WRITE' }) &&
            this._onCurrencyChange(value);
        }}
      >
        <Text>Set the default currency.</Text>
        <View style={settingsStyles.radioGroup}>{items}</View>
      </RadioGroup>
    );
  };

  _onCurrencyChange = (currency: unknown) => {
    if (typeof currency === 'string' && validCurrencies.has(currency)) {
      this.setState({ currency });
    }
  };

  _renderSaveControls = () => {
    let { account } = this.props;
    let { currency, isSaving } = this.state;
    if (getAccountCurrency(account) === currency) {
      return null;
    }
    let content;
    if (isSaving) {
      content = <LoadingIndicator />;
    } else {
      content = (
        <ButtonToolbar>
          <Button title="Revert" onPress={this._onReset} />
          <Button title="Save" onPress={this._onSave} isPrimary />
        </ButtonToolbar>
      );
    }
    return content;
  };

  _onSave = () => {
    let { account } = this.props;
    let { currency } = this.state;

    if (account) {
      let accountID = account.id;
      let updates = { currency };
      let postData = { account: { settings: updates } };
      postJSON(
        `/api/accounts/${accountID}/settings`,
        postData,
        (error, data) => {
          if (error) {
            console.error(error); // eslint-disable-line no-console
            let errorObject = ensureObject(error);
            let errorMessage = errorObject
              ? String(errorObject.message)
              : String(error);
            showError(`Unable to complete request: ${errorMessage}`);
            return;
          }
          if (data.success) {
            AccountActions.updateSettings(updates);
            showSuccess(`${updates.currency} is now your default currency.`);
          }
          this.setState({ isSaving: false });
        },
      );
      this.setState({ isSaving: true });
    }
  };

  _onReset = () => {
    this.setState({
      isSaving: false,
      currency: getAccountCurrency(this.props.account),
    });
  };
}

function getAccountCurrency(account: Account | null | undefined) {
  return account?.settings?.currency ?? 'USD';
}

const connector = connectData()(() => ({
  account: { dataStoreKey: 'account' },
  user: { dataStoreKey: 'user' },
}));
type FullProps = ConnectedProps<typeof connector>;
export default connector(CurrencySettings);
